export const commonModalClasses =
  "dark:bg-secondary bg-white drop-shadow-lg rounded p-6 space-y-6";

export const commonInputClasses =
  "w-full  outline-none border border-border rounde  text-sm w-full ";
